import { useState } from "react";
import { useForm } from "react-hook-form";
import { ParticipantChecklist } from "../interfaces/Participants";
import {
  PracticalUploadedFile,
  SELECTED_COMPETENCY_TYPE,
  SELECTED_FILE_TYPE
} from "../interfaces/Practical";

type Props = {
  onClose: () => void;
};

export const useFileUploadDialog = ({ onClose }: Props) => {
  const { control } = useForm();

  const [selectedFileType, setSelectedFileType] = useState<SELECTED_FILE_TYPE>(
    SELECTED_FILE_TYPE.DOCUMENT
  );
  const [selectCompetency, setSelectCompetency] = useState<SELECTED_COMPETENCY_TYPE>(
    SELECTED_COMPETENCY_TYPE.SELECTED
  );
  const [selectedChecklist, setSelectedChecklist] = useState<ParticipantChecklist[]>([]);
  const [files, setFiles] = useState<PracticalUploadedFile[]>([]);

  const handleSelectCompetencyChange = (_e: any, newValue: any) => {
    if (newValue !== null) setSelectCompetency(newValue);
  };

  const onDeleteChecklist = (e: any, checklistId: string) => {
    setSelectedChecklist((prev: ParticipantChecklist[]) =>
      prev.filter((item: ParticipantChecklist) => item.id !== checklistId)
    );
  };

  const onCloseDialog = () => {
    setFiles([]);
    setSelectedFileType(SELECTED_FILE_TYPE.DOCUMENT);
    setSelectCompetency(SELECTED_COMPETENCY_TYPE.SELECTED);
    onClose();
    setSelectedChecklist([]);
  };

  return {
    control,
    selectedFileType,
    selectCompetency,
    selectedChecklist,
    files,
    setFiles,
    setSelectedChecklist,
    setSelectedFileType,
    setSelectCompetency,
    handleSelectCompetencyChange,
    onCloseDialog,
    onDeleteChecklist
  };
};
